import { render, staticRenderFns } from "./Tag.vue?vue&type=template&id=3d38bddc&scoped=true&"
import script from "./Tag.vue?vue&type=script&lang=js&"
export * from "./Tag.vue?vue&type=script&lang=js&"
import style0 from "./Tag.vue?vue&type=style&index=0&id=3d38bddc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d38bddc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d38bddc')) {
      api.createRecord('3d38bddc', component.options)
    } else {
      api.reload('3d38bddc', component.options)
    }
    module.hot.accept("./Tag.vue?vue&type=template&id=3d38bddc&scoped=true&", function () {
      api.rerender('3d38bddc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/alerts/Tag.vue"
export default component.exports